import {
	warningCardHeader,
	successCardHeader,
	dangerCardHeader,
	infoCardHeader,
	primaryCardHeader,
	roseCardHeader,
	// grayColor,
	whiteCardHeader,
} from 'assets/jss/material-dashboard-pro-react';

const cardIconStyle = {
	cardIcon: {
		'&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader,&$whiteCardHeader': {
			// backgroundColor: grayColor[0],
			padding: '15px',
			marginTop: '-8px',
			float: 'left',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
	},
	xsIcon: {
		width: '24px',
		height: '24px',
		marginRight: '8px',
		borderRadius: '4px',
		padding: '4px!important',
		marginTop: '-2px!important',
		'& > *': {
			width: '100%',
		},
	},
	smIcon: {
		width: '40px',
		height: '40px',
		marginRight: '8px',
		borderRadius: '8px',
	},
	lgIcon: {
		width: '80px',
		height: '80px',
		marginRight: '16px',
		borderRadius: '3px',
	},
	warningCardHeader,
	successCardHeader,
	dangerCardHeader,
	infoCardHeader,
	primaryCardHeader,
	roseCardHeader,
	whiteCardHeader,
};

export default cardIconStyle;
